import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllAddress } from '../../redux/AddressSlice'
import { AddressCard } from '../index'
import { useNavigate } from 'react-router-dom'

function SelectDeliveryAddress({ selectedAddress, setSelectedAddress }) {
    const all_address = useSelector((state) => state.addressSlice.all_address)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        all_address === null && dispatch(getAllAddress())
    }, [all_address])

    return (
        <div style={{height : '100%', display : 'flex', justifyContent : 'space-between', flexDirection : 'column'}}>
            <div className='text-center h5'>Delivery Address</div>
            <div className='d-flex mt-4'>
                {
                    all_address && <div className='allAddress w-100'>
                        <AddressCard address={all_address[selectedAddress]} index={selectedAddress + 1} />
                    </div>
                }
            </div>
            <div className='d-flex mt-3'>
                {all_address && <button className='primaryButton h6 mt-3' data-bs-toggle="modal" data-bs-target="#exampleModal">Change Address</button>}
                {all_address === null || ( all_address && all_address.length < 5) ? <button className='primaryButton h6 mt-3' onClick={()=>navigate('/user/address/add/')}>Add Address</button> : <></>}
            </div>


            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Change Your Delivery Address</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body allAddress">
                            <div className='text-center'>Selected Address : Address-{selectedAddress + 1}</div>
                           {
                            all_address && all_address.map((item, index)=>{
                                return (
                                    <div className='mt-4' key={index} onClick={()=>setSelectedAddress(index)}>
                                      <AddressCard address={item} index={index + 1} showedit = {false} />    
                                    </div>
                                )
                            })
                           }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SelectDeliveryAddress